:host {
  display: block;
  width: 100%;
  max-width: var(--cms-container-max-width);
  margin: 0 auto;
  @include cms-base-font;
  margin-bottom: 0.75rem;
}

.text-link-wrapper {
  display: flex;
  flex: 0 0 100%;
  max-width: 100%;
  flex-wrap: wrap;
  background-color: css-var(semanticColors-transparency-strong-background);
  margin: 0 auto;
  align-items: center;
  padding: 1rem;
  border: 1px solid css-var(theme-border-color);
}

.text-link-label {
  display: flex;
  flex: 0 0 50%;
  max-width: 50%;
  justify-content: flex-start;
  font-family: var(--cms-font-trade-gothic);
  /*   flex: 0 0 100%;
  max-width: 100%; */
  color: css-var(theme-text-color);
}

.text-link-anchor {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}

@include media-width($breakpoint-sm) {
  /*   .text-link-wrapper {
    display: flex;
    flex: 0 0 66.6667%;
    max-width: 66.6667%;
    width: 66.6667%;
  } */

  /*   .text-link-label {
    flex: 0 0 50%;
    max-width: 50%;
    justify-content: flex-start;
  }

  .text-link-anchor {
    flex: 0 0 50%;
    max-width: 50%;
  } */
}
